let t = 0;
function n() {
  let e = "video-" + Date.now() + ++t;
  for (; document.getElementById(e); )
    e = "video-" + Date.now() + ++t;
  return e;
}
export {
  n as generateUniqueId
};
//# sourceMappingURL=generateUniqueId.mjs.map
